import { render, staticRenderFns } from "./CharactersAvailable.vue?vue&type=template&id=77137822&"
import script from "./CharactersAvailable.vue?vue&type=script&lang=js&"
export * from "./CharactersAvailable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports